import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Calendar from '../components/calendar';
import { useNavigate } from "react-router-dom";
import { BASE_URL, FITBIT_CLIENT_ID } from "../config";
import authStorage from "../utils/authStorage";

const Dashboard = () => {
    const navigate = useNavigate();
    const [garConnect, setGarConnect] = useState(false);
    const [fitConnect, setFitConnect] = useState(false);
	const [appleConnected, setAppleConnected] = useState(false);
    const [gartokConnect, setGartokConnect] = useState(false);
    //const [walkThroughPending, setWalkThroughPending] = useState(JSON.parse(authStorage.getItem("walkthough")).walkThroughPending);
    //const [walkThroughSteps, setWalkThroughSteps] = useState(JSON.parse(authStorage.getItem("walkthough")).walkThroughSteps);
    const getWalkthroughData = () => {
        try {
            const stored = authStorage.getItem("walkthrough"); // Fixed spelling
            if (!stored) return { walkThroughPending: false, walkThroughSteps: [] };
            
            // If already an object
            if (typeof stored === 'object') {
                return {
                    walkThroughPending: stored.walkThroughPending ?? false,
                    walkThroughSteps: stored.walkThroughSteps ?? []
                };
            }
            
            // If string, parse it
            const parsed = JSON.parse(stored);
            return {
                walkThroughPending: parsed.walkThroughPending ?? false,
                walkThroughSteps: parsed.walkThroughSteps ?? []
            };
        } catch (error) {
            console.error("Error reading walkthrough data:", error);
            return { walkThroughPending: false, walkThroughSteps: [] };
        }
    };

    const [walkThroughPending, setWalkThroughPending] = useState(() => 
        getWalkthroughData().walkThroughPending
    );
    const [walkThroughSteps, setWalkThroughSteps] = useState(() => 
        getWalkthroughData().walkThroughSteps
    );

    useEffect(() => {
        let userStatus = authStorage.getItem('status');
        let subscribedStatus = authStorage.getItem('subscribedStatus');
            if (subscribedStatus == 'false' ) {
            window.location = window.location.origin + '/membership';
            return false;
        } else if (fitConnect=='false' && garConnect =='false' && appleConnected == 'false' ) {
            navigate('/device');
        } 
        // else if (walkThroughPending =='true' || walkThroughSteps !== 2) {
        //     navigate('/device'); 
        // }
    }, []);

    useEffect(() => {
        const getDeviceStatus = async () => {
            try {
                const res = await axios({
                    headers: {
                        "x-access-token": authStorage.getItem("auth-token"),
                    },
                    url: `${BASE_URL}/user/device/status`,
                    method: "GET",
                });
                setGarConnect(res.data.isGarminConnected);
                setFitConnect(res.data.isFitbitConnected);
				setAppleConnected(res.data.isAppleConnected);
                setGartokConnect(res.data.isGarminConnectedthroughtoken);
            } catch (err) {
                if (err.code === "ERR_BAD_REQUEST") {
                    // Handle error
                }
            }
        };

        getDeviceStatus();
    }, []);

    useEffect(() => {
        if (!fitConnect && !garConnect && !appleConnected ) {
            navigate('/device');
        } else if (walkThroughPending || walkThroughSteps !== 2) {
            navigate('/device'); 
        }
    }, [fitConnect, garConnect, appleConnected, gartokConnect, walkThroughPending, walkThroughSteps, navigate]);

    const events = [{
        id: 1,
        color: '#FFFFFF',
        from: '2023-02-01',
        to: '2023-02-01',
        title: `⏱️2330 🔥2152`
    },
    {
        id: 2,
        color: '#FFFFFF',
        from: '2023-02-02',
        to: '2023-02-02',
        title: `⏱️2330 🔥2152`
    },
    {
        id: 1,
        color: '#FFFFFF',
        from: '2023-02-03',
        to: '2023-02-03',
        title: `⏱️2330 🔥2152`
    },
    {
        id: 2,
        color: '#FFFFFF',
        from: '2023-02-04',
        to: '2023-02-04',
        title: `⏱️2330 🔥2152`
    },
    {
        id: 1,
        color: '#FFFFFF',
        from: '2023-02-05',
        to: '2023-02-05',
        title: `⏱️2330 🔥2152`
    }, {
        id: 2,
        color: '#FFFFFF',
        from: '2023-02-06',
        to: '2023-02-06',
        title: `⏱️2330 🔥2152`
    }];

    return (
        <div className="dark:bg-slate-900 min-h-[88vh]">
            <div className="calendar-background">
                <Calendar events={events} />
            </div>
        </div>
    );
}

export default Dashboard;
